import type { AdminCrewReportStatisticsPdfExportButtonProps } from "../../models/admin-crew-report.models";
import {
  ADMIN_CREW_REPORT_STATISTICS_PDF_EXPORT_BUTTON_CLASS_NAME,
  ADMIN_CREW_REPORT_STATISTICS_PDF_EXPORT_LABEL,
  ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS,
} from "../../utils/admin-crew-report.constants";
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";

const AdminCrewReportStatisticsPdfExportButton = ({
  disabled,
  view,
  onClick,
}: AdminCrewReportStatisticsPdfExportButtonProps) => {
  const sectionTitle = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view].sectionTitle;

  return (
    <button
      type="button"
      aria-label={`${sectionTitle} ${ADMIN_CREW_REPORT_STATISTICS_PDF_EXPORT_LABEL}`}
      data-test={`admin-crew-report-statistics-${view}-pdf-export`}
      className={ADMIN_CREW_REPORT_STATISTICS_PDF_EXPORT_BUTTON_CLASS_NAME}
      disabled={disabled}
      onClick={onClick}
    >
      <DocumentArrowDownIcon
        data-testid="admin-crew-report-statistics-pdf-export-icon"
        className="h-3.5 w-3.5 flex-none"
        aria-hidden="true"
      />
      <span className="font-semibold uppercase">{sectionTitle}</span>
      <span className="text-[10px] font-normal normal-case">{ADMIN_CREW_REPORT_STATISTICS_PDF_EXPORT_LABEL}</span>
    </button>
  );
};

export default AdminCrewReportStatisticsPdfExportButton;
